import katex from "katex";

const selector2equation = [
  { selector: "gamma2", eq: `\\|\\gamma\\|_2^2` },
  { selector: "alpha2", eq: `\\alpha` },
  { selector: "beta2", eq: `\\beta` },
  { selector: "q", eq: `q` },
  { selector: "width", eq: `1/4` },
  { selector: "lq", eq: `L_q` },
  { selector: "q1", eq: `q \\ge 1` },
  { selector: "point1", eq: `1.25` },
  { selector: "point2", eq: `(2,1)` },
  { selector: "point3", eq: `2.5` },
  { selector: "point4", eq: `(3,1)` },
  { selector: "point5", eq: `125` },
  { selector: "point6", eq: `25` },
  { selector: "point7", eq: `1250` },
  { selector: "lp", eq: `L_p` },
  { selector: "lp2", eq: `L_p` },
  { selector: "point8", eq: `2.5` },
  { selector: "point9", eq: `2` },
  { selector: "point10", eq: `(2,1)` },
  { selector: "point11", eq: `0.9` },
  { selector: "point12", eq: `(2,1)` },
  { selector: "interval", eq: `[2-\\epsilon,2-\\epsilon/2]` },
  { selector: "interval2", eq: `[2.25,2.5]` },
  { selector: "smaller", eq: `1+s\\frac{1}{4}` },
  { selector: "slope2", eq: `s \\sim \\frac{1}{\\epsilon}` },
  { selector: "error", eq: `\\frac{1}{\\epsilon}` },
  {
    selector: "intervalp",
    eq: `
          \\left(\\frac{1}{2}\\right)^3\\left(\\frac{\\epsilon}{10}\\right) \\sim \\epsilon.`,
  },
  { selector: "epsilon", eq: `\\epsilon` },
  { selector: "epsilon2", eq: `\\epsilon` },
  { selector: "better", eq: `(2-\\epsilon,0.9)` },
  {
    selector: "slope",
    eq: `\\frac{0.1}{\\epsilon} \\sim \\frac{1}{\\epsilon}`,
  },
  { selector: "seq", eq: `\\epsilon= \\frac{1}{2^m}` },
  { selector: "fhat", eq: `\\hat{f}` },
  { selector: "f", eq: `f` },
  { selector: "q2", eq: `q` },
  { selector: "q3", eq: `q` },
  { selector: "qge1", eq: `q \\ge 1` },
  { selector: "interval3", eq: `[0,5]` },
  {
    selector: "estimate",
    eq: `\\mathbf{E}\\left[\\|\\hat f - f\\|_q^q\\right] \\gtrsim \\sum_{m=1}^\\infty \\frac{1}{2^m}\\left(2^m\\right)^q = \\sum_{m=1}^\\infty 2^{m(q-1)},`,
  },
  { selector: "prop1", eq: `(\\vec{x}, \\vec{y})` },
  { selector: "prop2", eq: `N \\ge 3` },
  { selector: "prop3", eq: `f` },
  { selector: "prop4", eq: `q \\ge 1` },
  { selector: "prop5", eq: `\\hat f` },
  { selector: "prop6", eq: `N-2` },
  {
    selector: "prop7",
    eq: `\\mathbf{E}\\left[\\|\\hat f - f\\|_q^q\\right] = \\infty.`,
  },
  { selector: "inf1", eq: `(t_k)_{k=1}^K` },
  { selector: "inf2", eq: `p(x)` },
  { selector: "inf3", eq: `\\|\\vec \\gamma\\|_2` },
  { selector: "inf4", eq: `g` },
  { selector: "inf5", eq: `t_{i-1},t_i,t_{i+1}` },
  { selector: "inf6", eq: `\\delta_i` },
  { selector: "inf7", eq: `\\delta_{i+1}` },
  { selector: "inf8", eq: `t_i` },
  { selector: "inf9", eq: `\\Delta_i` },
  { selector: "inf10", eq: `\\delta_i` },
  { selector: "inf11", eq: `\\delta_{i+1}` },
  { selector: "inf12", eq: `1` },
  { selector: "inf13", eq: `x` },
  { selector: "inf14", eq: `\\phi_k(x)` },
  { selector: "inf15", eq: `k \\neq i` },
  { selector: "inf16", eq: `\\delta_{i+1}-\\delta_i` },
  {
    selector: "inf17",
    eq: `\\gamma_i\\phi_i(x) = \\frac{\\gamma_i}{2} |x-t_i|`,
  },
  { selector: "inf18", eq: `\\gamma_i` },
  { selector: "inf19", eq: `\\delta_{i+1}-\\delta_i = \\gamma_i. ` },
  { selector: "inf20", eq: `g` },
  { selector: "inf21", eq: `\\delta_i` },
  { selector: "inf22", eq: `\\delta_{i+1}` },
  { selector: "inf23", eq: `g` },
  { selector: "inf24", eq: `t_i` },
  {
    selector: "inf25",
    eq: `g''(t_i) \\approx \\frac{\\delta_{i+1}-\\delta_i}{\\Delta_i} = \\frac{\\gamma_i}{\\Delta_i}`,
  },
  { selector: "inf26", eq: `p(x)` },
  { selector: "inf27", eq: `p(x)` },
  { selector: "inf28", eq: `\\Delta_i p(t_i)` },
  { selector: "inf29", eq: `K` },
  { selector: "inf30", eq: `p(x)` },
  { selector: "inf31", eq: `1/K` },
  { selector: "k0", eq: `(K=0)` },
  {
    selector: "inf32",
    eq: `\\Delta_i p(t_i) \\approx \\frac{1}{K} \\implies \\Delta_i \\approx \\frac{1}{Kp(t_i)}.`,
  },
  { selector: "inf33", eq: `\\sqrt{K}` },
  { selector: "inf34", eq: `\\sqrt{K} \\ll K` },
  { selector: "inf35", eq: `1 \\ll \\sqrt{K}` },
  {
    selector: "inf36",
    eq: `\\|\\vec \\gamma\\|_2^2 = \\sum_{k=0}^K \\gamma_k^2 \\approx \\sum_{k=0}^K g''(t_k)^2\\Delta_k^2.`,
  },
  { selector: "inf37", eq: `\\Delta_k` },
  {
    selector: "inf38",
    eq: `\\sum_{k=0}^K g''(t_k)^2\\Delta_k^2 \\approx \\frac{1}{K}\\sum_{k=0}^K \\frac{g''(t_k)^2}{p(t_k)}\\Delta_k.`,
  },
  { selector: "inf39", eq: `g''(x)^2/p(x)` },
  {
    selector: "inf40",
    eq: `\\|\\vec \\gamma\\|_2^2 \\approx \\frac{1}{K} \\int \\frac{g''(x)^2}{p(x)}dx.`,
  },
  { selector: "inf41", eq: `p(x)` },
  { selector: "inf42", eq: `g''(x) = 0` },
  { selector: "inf43", eq: `\\int_a^b g''(x)^2 dx.` },
  { selector: "inf44", eq: `L_2` },
  { selector: "inf45", eq: `\\hat f_k` },
  { selector: "inf46", eq: `k` },
  { selector: "inf47", eq: `f_k` },
  { selector: "inf48", eq: `L^q` },

  {
    selector: "points",
    eq: `\\begin{aligned}
  \\vec{x} &= (0,1,2,3,4,5)  \\\\
  \\vec{y} = 4\\left(\\vec{x}-\\frac{5}{2}\\right)^2 & = (25,9,1,1,9,25)
 \\end{aligned}`,
  },
  { selector: "input", eq: `\\vec{x} = (x_i)_{i = 1}^N` },
  { selector: "target", eq: `\\vec{y} = (y_i)_{i= 1}^N` },
  { selector: "knot", eq: `\\vec{t} = (t_k)_{k = 0}^K` },
  { selector: "radial", eq: `\\phi_k(x) = \\frac{1}{2}|x-t_k|,` },
  {
    selector: "model",
    eq: `\\alpha + \\beta x + \\sum_{k = 0}^K \\gamma_k\\phi_k(x),`,
  },
  { selector: "alpha", eq: `\\alpha` },
  { selector: "beta", eq: `\\beta` },
  { selector: "gamma", eq: `(\\gamma_k)_{k=0}^K` },
  { selector: "t1", eq: `t_k` },
  { selector: "t2", eq: `t_k` },
  { selector: "p1", eq: `p(x)` },
  { selector: "p2", eq: `p(x)` },
  { selector: "x", eq: `\\vec{x}` },
];

selector2equation.map((pair) => {
  katex.render(pair.eq, document.querySelector(`#katex-${pair.selector}`), {
    throwOnError: false,
  });
});
